import { Component } from "@angular/core";
import { FormGroup, FormBuilder, FormArray, Validators } from "@angular/forms";

import { SamlWizardService } from "../saml-wizard.service";
import { TranslateService } from "../../../../common/translate/translate.service";
import { SamlFormIdpAttributes } from "../models";
import { AbstractWizardStepComponent } from "../../../wizard-dialog/abstract-wizard-step.component";
import { SamlSummaryComponent } from "../saml-summary/saml-summary.component";
import { SamlUploadComponent } from "../saml-upload/saml-upload.component";

@Component({
	templateUrl: "./saml-attributes.component.html"
})
export class SamlAttributesComponent extends AbstractWizardStepComponent<void> {
	public form: FormGroup;
	public readonly deleteIcon = { type: "material", name: "delete_forever" };
	public readonly requiredAttributeCount = 1;

	constructor(
		private service: SamlWizardService,
		private formBuilder: FormBuilder,
		private translateService: TranslateService
	) {
		super();

		this.form = this.formBuilder.group({
			roleAttributes: this.formBuilder.array([])
		});
		this.service.identityProvider.roleAttributes.forEach((value) => {
			this.addAttribute(value);
		});
		if (this.service.isCreate && this.service.identityProvider.roleAttributes.length === 0) {
			this.addAttribute();
		}
	}

	public get roleAttributes() {
		return <FormArray>this.form.controls["roleAttributes"];
	}

	public addAttribute(value?: string) {
		this.roleAttributes.push(this.formBuilder.group({
			attribute: [
				value || "",
				Validators.compose([
					Validators.required,
					Validators.minLength(1)
				])
			]
		}));
	}

	public deleteAttribute(i: number) {
		this.roleAttributes.removeAt(i);
	}

	public get title() {
		const args = {
			samlIdp: this.service.identityProvider.name
		};
		return this.translateService.translate("saml.wizard.username.title", args);
	}

	public get description() {
		return "saml.wizard.username.description";
	}

	public get nextStep() {
		return SamlSummaryComponent;
	}

	public get previousStep() {
		return SamlUploadComponent;
	}

	public get isFormValid() {
		if (!this.form) {
			return true;
		}
		return this.form.valid;
	}

	public async performPrevious() {
		this.save();
	}

	public async performNext() {
		this.save();
	}

	public get showProgressBar() {
		return false;
	}

	private save() {
		this.service.processUsername(getAttributes(this.formValue));
	}

	private get formValue(): SamlFormIdpAttributes {
		return this.form.getRawValue();
	}
}

function getAttributes(raw: SamlFormIdpAttributes) {
	return {
		roleAttributes: getRoleAttributes(raw)
	};
}

function getRoleAttributes(raw: SamlFormIdpAttributes) {
	return raw.roleAttributes.map((a) => {
		return a.attribute;
	});
}
